<template>
    <!-- 添加/编辑对话框 -->
    <el-dialog 
        class="custom-dialog" 
        modal-class="custom-dialog-modal" 
        style="max-width:800px"
        v-model="formVisibleModel" 
        :title="form.add_update === 'add' ? '新規登録' : '詳細'" 
        align-center>
        <div class="flex-col w-full px-2 justify-center items-center">
            <!-- 表单内容 -->
            <el-form :model="form" :rules="rules" ref="formRef">
                
                <!-- JANコード部分 - 仅在新增时显示 -->
                <div class="w-full md:px-2" v-if="form.add_update === 'add'">
                    <el-form-item label="JANコード" prop="jancode" label-width="100px" :error="errorsModel?.jancode">
                        <el-input :model-value="form.jancode" autocomplete="off" placeholder="JANコード"
                            @input="$emit('update:form', { ...form, jancode: $event })">
                            <template #append>
                                <el-button 
                                    style="background-color: rgb(76, 175, 80); color: white; border: none; height: 100%; margin: 0; padding: 0 8px; border-right: 1px solid #dcdfe6;" 
                                    @click="handleScanStart">
                                    スキャンを開始
                                </el-button>
                                <el-button 
                                    style="background-color: rgb(21, 96, 130); color: white; border: none; height: 100%; margin: 0; padding: 0 8px; border-radius: 0 4px 4px 0;"
                                    @click="$emit('jancodeSearch', form.jancode || '')">
                                    検索
                                </el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </div>

                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item v-if="loginUserRole === ROLES.SYSTEM" label="組織" prop="organization_id" label-width="100px">
                            <OrganizationSelect 
                                :model-value="form.organization_id" 
                                :disabled="form.add_update === 'update'"
                                @update:model-value="$emit('update:form', { ...form, organization_id: $event })"
                                @organization-name-change="$emit('update:form', { ...form, organization_name: $event })" 
                                placeholder="組織を選択" />
                        </el-form-item>
                        
                        <el-form-item v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" 
                            label="部門" prop="department_id" label-width="100px">
                            <DepartmentSelect 
                                :organization-id="form.organization_id" 
                                :model-value="form.department_id" 
                                :disabled="form.add_update === 'update'"
                                @update:model-value="$emit('update:form', { ...form, department_id: $event })"
                                @department-name-change="$emit('update:form', { ...form, department_name: $event })" 
                                @organization-id-change="$emit('organizationIdChange', $event)" 
                                placeholder="部門を選択" />
                        </el-form-item>
                        
                        <el-form-item label="カテゴリ" prop="category_id" label-width="100px">
                            <CategorySelect 
                                :organization-id="form.organization_id" 
                                :model-value="form.category_id" 
                                :disabled="form.add_update === 'update'"
                                @update:model-value="$emit('update:form', { ...form, category_id: $event })"
                                @category-name-change="$emit('update:form', { ...form, category_name: $event })" 
                                placeholder="カテゴリを選択" />
                        </el-form-item>
                        
                        <el-form-item label="アイテム名" prop="material_code" label-width="100px">
                            <MaterialSelect 
                                :organization-id="form.organization_id" 
                                :category-id="form.category_id" 
                                :model-value="form.material_code" 
                                :disabled="form.add_update === 'update'"
                                @update:model-value="$emit('update:form', { ...form, material_code: $event })"
                                @material-name-change="$emit('update:form', { ...form, material_name: $event })" 
                                @update:organization-id="updateOrganizationId"
                                @update:category-id="updateCategoryId"
                                @update:expiration-day="updateExpirationDate"
                                placeholder="アイテム名を選択" />
                        </el-form-item>
                        
                        <el-form-item label="在庫数" prop="quantity" label-width="100px">
                            <el-input-number :model-value="form.quantity" :min="0" :max="999999" 
                                @update:model-value="$emit('update:form', { ...form, quantity: $event })" />
                        </el-form-item>
                    </div>
                    
                    <div class="w-full md:w-1/2 md:px-2">
                        <el-form-item label="保管日" prop="storage_date" label-width="100px">
                            <el-date-picker :model-value="form.storage_date" type="date" placeholder="保管日を選択"
                                @update:model-value="handleStorageDateChange" />
                        </el-form-item>
                        
                        <el-form-item label="有効期限" prop="expiration_date" label-width="100px">
                            <el-date-picker :model-value="form.expiration_date" type="date" placeholder="有効期限を選択"
                                @update:model-value="handleExpirationDateChange" />
                        </el-form-item>
                        
                        <el-form-item label="保管場所" prop="location" label-width="100px">
                            <el-input :model-value="form.location" autocomplete="off" placeholder="保管場所を入力"
                                @input="$emit('update:form', { ...form, location: $event })" />
                        </el-form-item>
                        
                        <el-form-item label="コメント" prop="comment" label-width="100px">
                            <el-input :model-value="form.comment" autocomplete="off" placeholder="コメントを入力"
                                @input="$emit('update:form', { ...form, comment: $event })" />
                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <!-- 图片上传 -->
            <div class="flex w-full items-center justify-center">
                <el-upload 
                    action="#" 
                    list-type="picture-card" 
                    :auto-upload="false" 
                    :on-change="handleImageChange" 
                    multiple
                    :on-remove="handleImageRemove" 
                    :limit="3" 
                    :on-exceed="handleExceed" 
                    :file-list="fileList" 
                    accept=".jpg,.jpeg,.png,.webp,.gif">
                    <el-icon>
                        <Plus />
                    </el-icon>
                    <template #file="{ file }">
                        <div class="w-full">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <el-icon><zoom-in /></el-icon>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete"
                                    @click="$emit('imageRemove', file)">
                                    <el-icon>
                                        <Delete />
                                    </el-icon>
                                </span>
                            </span>
                        </div>
                    </template>
                </el-upload>
            </div>
        </div>

        <!-- 扫描器容器 -->
        <div class="flex flex-col w-full">
            <div class="barcode-scanner-container" v-if="barcodeScannerState">
                <BarcodeScanner 
                    ref="barcodeScannerRef" 
                    @code-scanned="handleScanSuccess" 
                    @scan-stopped="barcodeScannerState = false" 
                />
            </div>
        </div>

        <template #footer>
            <div class="dialog-footer flex items-center">
                <el-button 
                    v-if="form.add_update === 'update' && formShowDel"
                    type="danger"
                    @click="$emit('delete', form.inventory_id, form.sk)">
                    削除
                </el-button>
                <div class="flex gap-2 ml-auto">
                    <el-button @click="formVisibleModel = false">キャンセル</el-button>
                    <el-button type="primary" @click="handleSubmit">
                        {{ form.add_update === 'add' ? '登録' : '更新' }}
                    </el-button>
                </div>
            </div>
        </template>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <el-dialog 
        class="custom-dialog" 
        modal-class="custom-dialog-modal" 
        style="max-width:800px"
        v-model="imagePreviewVisibleModel" 
        align-center>
        <div class="flex justify-center items-center">
            <img w-full :src="dialogImageUrl" alt="Preview Image" />
        </div>
    </el-dialog>

    <!-- アラート设置对话框 -->
    <el-dialog 
        class="custom-dialog" 
        modal-class="custom-dialog-modal" 
        v-model="alarmVisibleModel"
        title="アラート設定" 
        align-center>
        <el-form :model="alarmForm" :rules="alarmRules" ref="alarmFormRef">
            <el-form-item label="責任者" prop="responsible_person">
                <UserSelect 
                    :organization-id="alarmForm.organization_id" 
                    :model-value="alarmForm.responsible_person"
                    @update:model-value="$emit('update:alarmForm', { ...alarmForm, responsible_person: $event })"
                    placeholder="責任者を選択" />
            </el-form-item>
            
            <el-form-item label="アラート設定" prop="alarm_setting">
                <el-checkbox-group :model-value="alarmForm.alarm_setting"
                    @update:model-value="$emit('update:alarmForm', { ...alarmForm, alarm_setting: $event })">
                    <el-checkbox label="1日以内">1日以内</el-checkbox>
                    <el-checkbox label="1日前">1日前</el-checkbox>
                    <el-checkbox label="7日前">7日前</el-checkbox>
                    <el-checkbox label="15日前">15日前</el-checkbox>
                    <el-checkbox label="30日前">30日前</el-checkbox>
                    <el-checkbox label="在庫数">在庫数</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            
            <el-form-item label="在庫数" prop="quantity" v-if="alarmForm.alarm_setting.includes('在庫数')">
                <el-input-number :model-value="alarmForm.quantity" :min="0" :max="999999"
                    @update:model-value="$emit('update:alarmForm', { ...alarmForm, quantity: $event })" />
            </el-form-item>
            
            <el-form-item label="有効">
                <el-switch :model-value="alarmForm.is_actived" active-value="1" inactive-value="0"
                    @update:model-value="$emit('update:alarmForm', { ...alarmForm, is_actived: $event })" />
            </el-form-item>
        </el-form>
        
        <template #footer>
            <div class="dialog-footer flex items-center">
                <el-button 
                    v-if="alarmForm.add_update === 'update'"
                    type="danger" 
                    @click="$emit('deleteReminder')">
                    削除
                </el-button>
                <div class="flex gap-2 ml-auto">
                    <el-button @click="alarmVisibleModel = false">キャンセル</el-button>
                    <el-button type="primary" @click="handleAlarmSubmit">
                        {{ alarmForm.add_update === 'add' ? '登録' : '更新' }}
                    </el-button>
                </div>
            </div>
        </template>
    </el-dialog>

    <!-- 定数设置对话框 -->
    <el-dialog 
        class="custom-dialog" 
        modal-class="custom-dialog-modal" 
        v-model="constantVisibleModel"
        :title="constantSettingLevel === 'organization' ? '組織定数設定' : '部門定数設定'" 
        align-center>
        <el-form :model="constantForm" :rules="constantRules" ref="constantFormRef">
            <!-- 暂时隐藏责任人字段 -->
            <!-- <el-form-item label="責任者">
                <UserSelect 
                    :organization-id="constantForm.organization_id" 
                    :model-value="constantForm.responsible_person"
                    @update:model-value="$emit('update:constantForm', { ...constantForm, responsible_person: $event })"
                    :placeholder="constantSettingLevel === 'organization' ? '組織管理者のみを入力してください' : '部門管理者以上を入力してください'" />
            </el-form-item> -->
            
            <el-form-item label="定数">
                <el-input-number :model-value="constantForm.constant_value" :min="0" :max="999999"
                    @update:model-value="$emit('update:constantForm', { ...constantForm, constant_value: $event })" />
            </el-form-item>
        </el-form>
        
        <template #footer>
            <div class="dialog-footer flex items-center">
                <div class="flex gap-2 ml-auto">
                    <el-button @click="constantVisibleModel = false">キャンセル</el-button>
                    <el-button type="primary" @click="handleConstantSubmit">
                        {{ constantForm.add_update === 'add' ? '登録' : '更新' }}
                    </el-button>
                </div>
            </div>
        </template>
    </el-dialog>

    <!-- 払い出し对话框 -  -->
    <el-dialog 
        class="custom-dialog transfer-dialog"
        modal-class="custom-dialog-modal" 
        style="max-width:800px"
        v-model="transferInventoryVisibleModel" 
        :title="transferInventoryStep !== 2 ? '払い出し' : '払い出し（選択）'" align-center>

        <!-- 第一步：选择目标部门以及转移数量 -->
        <div v-if="transferInventoryStep !== 2">
            <el-form 
                :model="transferInventoryForm" 
                :rules="transferFormRules"
                ref="transferInventoryFormRef" 
                label-width="120px">
                <el-form-item label="アイテム名" label-width="120px">
                    <span>{{ transferInventoryForm.material_name }}</span>
                </el-form-item>

                <div class="flex flex-col md:flex-row">
                    <div class="flex-1">
                        <el-form-item label="部門（元）" label-width="120px">
                            <span>{{ transferInventoryForm.department_name }}</span>
                        </el-form-item>
                    </div>
                    
                    <div class="flex-1">
                        <el-form-item 
                            prop="dest_department_id"
                            label-width="120px">
                            <template #label>
                                <div class="flex items-center">
                                    <span class="material-symbols-outlined text-lg text-gray-500 mr-2">
                                        arrow_forward
                                    </span>
                                    <span>部門（先）</span>
                                </div>
                            </template>
                            <DepartmentSelect 
                                :organization-id="transferInventoryForm.organization_id" 
                                :model-value="transferInventoryForm.dest_department_id" 
                                :is-exclude-target-department="true"
                                :target-department-id="transferInventoryForm.department_id"
                                @update:model-value="handleDepartmentChange"
                                @department-name-change="$emit('update:transferInventoryForm', { ...transferInventoryForm, dest_department_name: $event })" 
                                placeholder="部門を選択" />
                        </el-form-item>
                    </div>
                </div>

                <el-form-item label="個数" prop="transfer_quantity">
                    <el-input-number 
                        :model-value="transferInventoryForm.transfer_quantity" 
                        :min="0" 
                        :max="transferInventoryForm.quantity"
                        @update:model-value="handleTransferQuantityChange" />
                </el-form-item>

                <el-form-item label="操作者" prop="transfer_operator" label-width="120">
                    <el-input 
                        maxlength="10" 
                        width="120px" 
                        :model-value="transferInventoryForm.transfer_operator" 
                        placeholder="操作者を入力" 
                        autocomplete="off"
                        @input="$emit('update:transferInventoryForm', { ...transferInventoryForm, transfer_operator: $event })" />
                </el-form-item> 

                <el-form-item label="メモ">
                    <el-input 
                        type="textarea"
                        :model-value="transferInventoryForm.transfer_memo" 
                        autocomplete="off" 
                        placeholder="メモを入力"
                        :autosize="{ minRows: 2, maxRows: 5 }"
                        @input="$emit('update:transferInventoryForm', { ...transferInventoryForm, transfer_memo: $event })" />
                </el-form-item>

            </el-form>
        </div>

        <!-- 第二步：选择入库目标库存记录，或是选择新建记录 -->
        <div v-if="transferInventoryStep === 2">
            <!-- Title -->
            <div class="mb-4">
                <h3 class="text-lg font-medium text-gray-900">{{ transferInventoryForm.material_name }} （保管日：{{ formatDate(transferInventoryForm.storage_date) }}，有効期限：{{ formatDate(transferInventoryForm.expiration_date) }}）</h3>
            </div>
            
            <!-- Create New Record Button (Above Table) -->
            <!-- <div 
                class="w-full mb-2 new-record-fake-row cursor-pointer border border-gray-300 rounded"
                @click="handleCreateNewRecord">
                <div class="flex items-center px-4 h-full">
                    <span 
                        class="material-symbols-outlined text-white mr-3"
                        style="font-size: 20px;">
                        add
                    </span>
                    <span class="text-white font-medium">新しい在庫レコードを作成</span>
                </div>
            </div> -->
            
            <!-- Target inventory table with header -->
            <el-table 
                v-loading="targetInventoryListLoading"
                :data="sortedPaginatedTargetInventory" 
                style="width: 100%"
                border
                highlight-current-row
                header-row-class-name="table-header-row">
                <el-table-column 
                    label=""
                    width="50"
                    align="center">
                    <template #default="{ row }">
                        <div class="flex justify-center items-center w-full h-full">
                            <el-radio 
                                :model-value="selectedTargetInventoryId" 
                                :label="row.inventory_id"
                                @update:model-value="handleTargetInventorySelect(row)"
                                class="radio-center">
                                <span></span>
                            </el-radio>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="storage_date" 
                    width="120"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('storage_date')">
                            <span>{{ getTargetInventorySortLabel('storage_date') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'storage_date' }">
                                    {{ getTargetInventorySortIcon('storage_date') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                    <template #default="{ row }">
                        {{ formatDate(row.storage_date) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="expiration_date" 
                    width="120"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('expiration_date')">
                            <span>{{ getTargetInventorySortLabel('expiration_date') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'expiration_date' }">
                                    {{ getTargetInventorySortIcon('expiration_date') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                    <template #default="{ row }">
                        {{ formatDate(row.expiration_date) }}
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="quantity" 
                    width="100"
                    align="left">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('quantity')">
                            <span>{{ getTargetInventorySortLabel('quantity') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'quantity' }">
                                    {{ getTargetInventorySortIcon('quantity') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="location" 
                    min-width="120">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('location')">
                            <span>{{ getTargetInventorySortLabel('location') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'location' }">
                                    {{ getTargetInventorySortIcon('location') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    prop="comment" 
                    min-width="120">
                    <template #header>
                        <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleTargetInventorySort('comment')">
                            <span>{{ getTargetInventorySortLabel('comment') }}</span>
                            <el-icon class="ml-1 flex-shrink-0">
                                <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': targetInventorySortField === 'comment' }">
                                    {{ getTargetInventorySortIcon('comment') }}
                                </span>
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            
            <!-- Pagination controls for target inventory table -->
            <div class="flex justify-end mt-4" v-if="targetInventoryTotal > targetInventoryPageSize">
                <el-pagination
                    v-model:current-page="targetInventoryCurrentPage"
                    :page-size="targetInventoryPageSize"
                    :total="targetInventoryTotal"
                    layout="prev, pager, next"
                    @current-change="handleTargetInventoryPageChange"
                />
            </div>
        </div>

        <template #footer>
            <div class="dialog-footer flex flex-col">
                <!-- Step 2 Error Display Area -->
                <div v-if="transferInventoryStep === 2" class="flex justify-end mb-2 min-h-6">
                    <div v-if="step2Error" class="text-red-500 text-sm">
                        {{ step2Error }}
                    </div>
                </div>
                
                <!-- Buttons -->
                <div class="flex items-center">
                    <div class="flex gap-2 ml-auto">
                        <el-button @click="transferInventoryVisibleModel = false">キャンセル</el-button>
                        <el-button 
                            type="primary" 
                            @click="handleTransferInventorySubmit" :loading="targetInventoryListLoading">
                            払い出し
                        </el-button>
                    </div>
                </div>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, ZoomIn, Delete } from '@element-plus/icons-vue';
import { ROLES, IMG_MAX_SIZE } from '@/config/constants';
import type { FormRules } from 'element-plus';
import type { UploadFile } from 'element-plus';
import axios, { AxiosResponse } from 'axios';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import CategorySelect from '@/components/common/CategorySelect.vue';
import MaterialSelect from '@/components/common/MaterialSelect.vue';
import UserSelect from '@/components/common/UserSelect.vue';
import BarcodeScanner from '@/components/common/BarcodeScanner.vue';
import { sortingUtil, SortConfig } from '@/components/common/SortingUtil';
import { formatDateTime, isNoExpiryDate, resolveExpirationDateFromDay } from '@/components/common/StringUtils';
import { ResponseStatus, ErrorCode } from '@/components/common/response';
import type { UploadImageResponseData } from '@/components/common/response';

type ScanMeta = {
    rawText?: string;
    format?: string;
    expirationDate?: string | null;
};

export default defineComponent({
    name: 'InventoryDialogs',
    components: {
        Plus,
        ZoomIn,
        Delete,
        OrganizationSelect,
        DepartmentSelect,
        CategorySelect,
        MaterialSelect,
        UserSelect,
        BarcodeScanner,
    },
    props: {
        formVisible: {
            type: Boolean,
            default: false,
        },
        alarmVisible: {
            type: Boolean,
            default: false,
        },
        constantVisible: {
            type: Boolean,
            default: false,
        },
        imagePreviewVisible: {
            type: Boolean,
            default: false,
        },
        transferInventoryVisible: {
            type: Boolean,
            default: false,
        },
        transferInventoryStep: {
            type: Number,
            default: 1,
        },
        form: {
            type: Object,
            required: true,
        },
        alarmForm: {
            type: Object,
            required: true,
        },
        constantForm: {
            type: Object,
            required: true,
        },
        transferInventoryForm: {
            type: Object,
            required: true,
        },
        targetInventoryList: {
            type: Array,
            default: () => [],
        },
        targetInventoryListLoading: {
            type: Boolean,
            default: false,
        },
        selectedTargetInventoryId: {
            type: String,
            default: '',
        },
        dialogImageUrl: {
            type: String,
            default: '',
        },
        fileList: {
            type: Array,
            default: () => [],
        },
        formShowDel: {
            type: Boolean,
            default: false,
        },
        loginUserRole: {
            type: String,
            required: true,
        },
        loginUserRoleIsHead: {
            type: Boolean,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        constantSettingLevel: {
            type: String as () => 'organization' | 'department',
            default: 'organization',
        },
    },
    emits: [
        'update:formVisible', 
        'update:alarmVisible', 
        'update:constantVisible',
        'update:imagePreviewVisible',
        'update:transferInventoryVisible',
        'update:transferInventoryStep',
        'update:form',
        'update:alarmForm',
        'update:constantForm',
        'update:transferInventoryForm',
        'update:targetInventoryList',
        'update:errors',
        'submit', 
        'alarmSubmit', 
        'constantSubmit',
        'deleteReminder',
        'imageChange', 
        'imageRemove', 
        'imagePreview',
        'scanStart', 
        'jancodeSearch',
        'delete',
        'transferInventorySubmit',
        'transferInventoryRequestTargetInventoryList',
        'targetInventorySelect',
        'createNewRecord',
        'scanSuccess',
        'organizationIdChange'
    ],
    setup(props, { emit }) {
        const loginUserIsPayMust = localStorage.getItem('is_pay_must');

        const formRef = ref();
        const alarmFormRef = ref();
        const constantFormRef = ref();
        const transferInventoryFormRef = ref();
        const disabled = ref(false);
        const barcodeScannerRef = ref<any>(null);
        const barcodeScannerState = ref<boolean>(false);
        // When true, scanned expiration date has higher priority than item-master autofill.
        const hasScannedExpirationPriority = ref(false);
        
        // 图片上传相关状态
        const imageUrl = ref<string>('');
        
        // Error state for step 2 (step 1 uses Element Plus form validation)
        const step2Error = ref('');

        // Sort configuration for target inventory table
        const targetInventorySortConfig: SortConfig = {
            storage_date: {
                label: '保管日',
                mobileLabel: '保管日',
                type: 'date',
                defaultOrder: 'desc'
            },
            expiration_date: {
                label: '有効期限',
                mobileLabel: '有効期限',
                type: 'date',
                defaultOrder: 'asc'
            },
            quantity: {
                label: '在庫数',
                mobileLabel: '在庫数',
                type: 'number',
                defaultOrder: 'desc'
            },
            location: {
                label: '保管場所',
                mobileLabel: '保管場所',
                type: 'string',
                defaultOrder: 'asc'
            },
            comment: {
                label: 'コメント',
                mobileLabel: 'コメント',
                type: 'string',
                defaultOrder: 'asc'
            }
        };

        // Initialize sorting utility for target inventory
        const {
            handleSort: handleTargetInventorySort,
            getSortLabel: getTargetInventorySortLabel,
            getSortIcon: getTargetInventorySortIcon,
            paginatedData: sortedPaginatedTargetInventory,
            currentPage: targetInventoryCurrentPage,
            pageSize: targetInventoryPageSize,
            totalRecords: targetInventoryTotal,
            handlePageChange: handleTargetInventoryPageChange,
            sortField: targetInventorySortField,
        } = sortingUtil(
            computed(() => props.targetInventoryList as any[]),
            targetInventorySortConfig
        );

        // Set initial page size to 5
        targetInventoryPageSize.value = 5;

        // 双向绑定计算属性
        const formVisibleModel = computed({
            get: () => props.formVisible,
            set: (value) => emit('update:formVisible', value)
        });

        const alarmVisibleModel = computed({
            get: () => props.alarmVisible,
            set: (value) => emit('update:alarmVisible', value)
        });

        const constantVisibleModel = computed({
            get: () => props.constantVisible,
            set: (value) => emit('update:constantVisible', value)
        });

        const imagePreviewVisibleModel = computed({
            get: () => props.imagePreviewVisible,
            set: (value) => emit('update:imagePreviewVisible', value)
        });

        const transferInventoryVisibleModel = computed({
            get: () => props.transferInventoryVisible,
            set: (value) => emit('update:transferInventoryVisible', value)
        });

        const transferInventoryStepModel = computed({
            get: () => props.transferInventoryStep,
            set: (value) => emit('update:transferInventoryStep', value)
        });

        // 错误信息计算属性
        const errorsModel = computed(() => props.errors);





        // 监听对话框打开状态，清除验证错误
        watch(() => props.formVisible, (newVal) => {
            if (newVal && formRef.value) {
                // Reset scanned-priority lock for a fresh add/edit session.
                hasScannedExpirationPriority.value = false;
                // 对话框打开时，清除所有验证错误
                nextTick(() => {
                    formRef.value.clearValidate();
                });
            }
        });

        // 监听报警设置对话框打开状态，清除验证错误
        watch(() => props.alarmVisible, (newVal) => {
            if (newVal && alarmFormRef.value) {
                // 对话框打开时，清除所有验证错误
                nextTick(() => {
                    alarmFormRef.value.clearValidate();
                });
            }
        });

        // 监听转移步骤变化，当到达第二步时获取目标库存列表
        watch(() => props.transferInventoryStep, (newStep) => {
            if (newStep === 1) {
                // Clear step 2 error when going back to step 1
                step2Error.value = '';
                // Ensure form validation is cleared when returning to step 1
                nextTick(() => {
                    if (transferInventoryFormRef.value) {
                        transferInventoryFormRef.value.clearValidate();
                    }
                });
            }
        });

        watch(() => props.targetInventoryList, (newList) => {
            if(transferInventoryStepModel.value !== 1.5){
                return;
            }

            const targetInventoryList = newList as any[];

            if (targetInventoryList.length === 0) {
                handleCreateNewRecord();
            }else if (targetInventoryList.length === 1) {
                transferInventory(targetInventoryList[0].inventory_id, targetInventoryList[0].sk);
            }else if (targetInventoryList.length > 1) {
                transferInventoryStepModel.value = 2;
            }
        });

        // 监听对话框打开状态，清除转移错误
        watch(() => props.transferInventoryVisible, (newVal) => {
            if (newVal) {
                step2Error.value = '';
                // Reset pagination when dialog opens
                targetInventoryCurrentPage.value = 1;
                // Clear form validation errors when dialog opens
                nextTick(() => {
                    if (transferInventoryFormRef.value) {
                        transferInventoryFormRef.value.clearValidate();
                    }
                });
            }
        });

        // 监听表单对话框打开状态，管理扫描器状态
        watch(() => props.formVisible, (newVal, oldVal) => {
            // If the dialog is being closed (changing from true to false)
            if (oldVal === true && newVal === false) {
                hasScannedExpirationPriority.value = false;
                // Reset the barcode scanner state
                barcodeScannerState.value = false;
                
                // Also stop scanning if it's in progress
                if (barcodeScannerRef.value) {
                    (barcodeScannerRef.value as any).resetScannerState();
                }
            }
        });





        // 表单验证规则
        const rules = ref<FormRules>({
            organization_id: [
                { required: true, message: '組織を選択してください', trigger: 'blur' }
            ],
            department_id: [
                { required: true, message: '部門を選択してください', trigger: 'blur' }
            ],
            category_id: [
                { required: true, message: 'カテゴリを選択してください', trigger: 'blur' }
            ],
            material_code: [
                { required: true, message: 'アイテム名を選択してください', trigger: 'blur' }
            ],
            quantity: [
                { required: true, message: '数量を入力してください', trigger: 'blur' },
                { type: 'number', min: 0, message: '数量は0以上の数字を入力してください', trigger: 'blur' }
            ],
            storage_date: [
                { required: true, message: '保管日を選択してください', trigger: 'blur' }
            ],
            expiration_date: [
                { required: true, message: '有効期限を選択してください', trigger: 'blur' }
            ]
        });

        const alarmRules = ref<FormRules>({
            responsible_person: [
                { required: true, message: '責任者を選択してください', trigger: 'blur' }
            ],
            alarm_setting: [
                { required: true, type: 'array', min: 1, message: 'アラート設定を選択してください', trigger: 'blur' }
            ],
            quantity: [
                { 
                    validator: (rule: any, value: any, callback: any) => {
                        if (props.alarmForm.alarm_setting && props.alarmForm.alarm_setting.includes('在庫数')) {
                            if (!value || value <= 0) {
                                callback(new Error('在庫数を入力してください'));
                            } else {
                                callback();
                            }
                        } else {
                            callback();
                        }
                    }, 
                    trigger: 'blur' 
                }
            ],
        });

        const constantRules = ref<FormRules>({ // Added constantRules
            // 暂时移除责任人字段的验证，因为已经隐藏了
            // responsible_person: [
            //     { required: true, message: '責任者を選択してください', trigger: 'blur' }
            // ],
            constant_value: [
                { required: true, message: '定数を入力してください', trigger: 'blur' },
                { type: 'number', min: 0, message: '定数は0以上の数字を入力してください', trigger: 'blur' }
            ]
        });

        const transferFormRules = ref<FormRules>({
            dest_department_id: [
                { required: true, message: '先部門を選択してください', trigger: 'change' }
            ],
            transfer_quantity: [
                { required: true, message: '払い出し個数を入力してください', trigger: 'blur' },
                { type: 'number', min: 1, message: '払い出し個数は1以上の数字を入力してください', trigger: 'blur' },
                { 
                    validator: (rule: any, value: any, callback: any) => {
                        if (value > props.transferInventoryForm.quantity) {
                            callback(new Error('払い出し個数が在庫数を超えています'));
                        } else {
                            callback();
                        }
                    }, 
                    trigger: 'blur' 
                }
            ],
            transfer_operator: [
                { required: loginUserIsPayMust === '1', message: '操作者を入力してください', trigger: 'blur' }
            ]
        });

        const handleExceed = () => {
            ElMessage.warning('最大3枚までアップロードできます。');
        };

        const handleImageChange = (file: any) => {
            if (props.fileList.length >= 4) {
                ElMessage.warning('最大3枚までアップロードできます。');
                return false;
            }
            
            // 创建图片预览URL
            imageUrl.value = URL.createObjectURL(file.raw || new Blob());
            
            // 只是将文件信息传递给父组件，不立即上传
            emit('imageChange', file);
        };

        const handleImageRemove = (file: any) => {
            emit('imageRemove', file);
        };

        const handlePictureCardPreview = (file: any) => {
            emit('imagePreview', file);
        };

        const updateOrganizationId = (newOrganizationId: string) => {
            emit('update:form', { ...props.form, organization_id: newOrganizationId });
        };

        const updateCategoryId = (newCategoryId: string) => {
            emit('update:form', { ...props.form, category_id: newCategoryId });
        };

        const updateExpirationDate = (newExpirationDay: number) => {
            if (hasScannedExpirationPriority.value) {
                return;
            }

            // Edit mode keeps inventory expiration_date; do not recalc from item master.
            if (props.form.add_update === 'update') {
                return;
            }

            const calculatedDate = resolveExpirationDateFromDay(
                newExpirationDay,
                props.form.storage_date
            );

            if (!calculatedDate) {
                return;
            }

            emit('update:form', { ...props.form, expiration_date: calculatedDate });
        };

        const handleExpirationDateChange = (value: string) => {
            // User manual edit should take precedence over all autofill strategies.
            hasScannedExpirationPriority.value = false;
            emit('update:form', { ...props.form, expiration_date: value });
        };

        const handleStorageDateChange = (value: string) => {
            let updatedForm:any = {
                ...props.form,
                storage_date: value,
            };

            // 没有物料编号 → 只更新 storage_date
            if (!props.form.material_code) {
                emit('update:form', updatedForm);
                return;
            }

            // 如果有 expiration_date → 需要联动平移（无期限 2999-12-31 不随保管日平移）
            if (props.form.expiration_date && !isNoExpiryDate(props.form.expiration_date)) {
                const diffDays = getDateDiffDays(props.form.storage_date, value);

                const baseDate = new Date(props.form.expiration_date);
                baseDate.setDate(baseDate.getDate() + diffDays);

                updatedForm.expiration_date = baseDate.toISOString();
            }

            emit('update:form', updatedForm);
        };

        const getDateDiffDays = (date1: string | Date, date2: string | Date) => {
            const d1 = new Date(date1);
            const d2 = new Date(date2);

            const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
            const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());

            return Math.floor((utc2 - utc1) / 86400000);
        };

        const handleSubmit = () => {
            formRef.value.validate((valid: boolean) => {
                if (valid) {
                    emit('submit');
                    formVisibleModel.value = false;
                }
            });
        };

        const handleAlarmSubmit = () => {
            alarmFormRef.value.validate((valid: boolean) => {
                if (valid) {
                    emit('alarmSubmit');
                    alarmVisibleModel.value = false;
                }
            });
        };

        const handleConstantSubmit = () => {
            constantFormRef.value.validate((valid: boolean) => {
                if (valid) {
                    emit('constantSubmit');
                    constantVisibleModel.value = false;
                }
            });
        };

        const handleDepartmentChange = (value: string) => {
            emit('update:transferInventoryForm', { ...props.transferInventoryForm, dest_department_id: value });
        };

        const handleTransferQuantityChange = (value: number) => {
            emit('update:transferInventoryForm', { ...props.transferInventoryForm, transfer_quantity: value });
        };

        const handleTransferInventorySubmit = () => {
            if (transferInventoryStepModel.value === 1) {
                // Step 1: Use Element Plus form validation
                if (!transferInventoryFormRef.value) {
                    console.error('Transfer form ref is not available');
                    return;
                }
                
                transferInventoryFormRef.value.validate((valid: boolean) => {
                    if (valid) {
                        transferInventoryStepModel.value = 1.5;
                        emit('transferInventoryRequestTargetInventoryList');
                    }
                });
            } else if (transferInventoryStepModel.value === 2) {
                // Step 2 validation: Check if a target inventory is selected
                if (!props.selectedTargetInventoryId || props.selectedTargetInventoryId === '') {
                    step2Error.value = '先在庫を選択してください';
                    return;
                }
                
                // Clear step 2 error if validation passes
                step2Error.value = '';
                
                // For step 2, we don't need form validation for the table selection
                // The form validation was only needed for step 1
                // 获取选择的目标库存
                const selectedInventory = (props.targetInventoryList as any[]).find((item: any) => item.inventory_id === props.selectedTargetInventoryId);

                transferInventory(selectedInventory?.inventory_id || '', selectedInventory?.sk || '');
            }
        };

        const transferInventory = (destInventoryId: string, destSk: string) => {
            // 处理 transfer_memo：将 transfer_operator 加在 memo 前面，并加上换行
            let processedMemo = props.transferInventoryForm.transfer_memo || '';
            if (props.transferInventoryForm.transfer_operator && props.transferInventoryForm.transfer_operator.trim()) {
                processedMemo = '\n' + "操作者：" + props.transferInventoryForm.transfer_operator.trim() + '\n' + processedMemo;
            }
            
            // Set transfer flag on the form data
            emit('update:transferInventoryForm', { 
                ...props.transferInventoryForm, 
                dest_inventory_id: destInventoryId,
                dest_sk: destSk,
                transfer_memo: processedMemo,
                is_transfer: true 
            });
            
            emit('transferInventorySubmit');
            transferInventoryVisibleModel.value = false;
        };

        const handleCreateNewRecord = () => {
            // For new record creation, bypass row selection validation
            
            // 处理 transfer_memo：将 transfer_operator 加在 memo 前面，并加上换行
            let processedMemo = props.transferInventoryForm.transfer_memo || '';
            if (props.transferInventoryForm.transfer_operator && props.transferInventoryForm.transfer_operator.trim()) {
                processedMemo = '\n' + "操作者：" + props.transferInventoryForm.transfer_operator.trim() + '\n' + processedMemo;
            }
            
            // Set the create new record flag on the form data
            emit('update:transferInventoryForm', { 
                ...props.transferInventoryForm, 
                dest_inventory_id: '',
                dest_sk: '',
                transfer_memo: processedMemo,
                is_create_new_record: true 
            });
            
            emit('createNewRecord');
            // Close the dialog since we're creating a new record
            transferInventoryVisibleModel.value = false;
        };

        const handleTargetInventorySelect = (row: any) => {
            emit('targetInventorySelect', {
                inventory_id: row.inventory_id,
                sk: row.sk
            });
        };



        const formatDate = (dateString: string) => {
            if (!dateString) return '';
            try {
                return formatDateTime(dateString, 'YYYY-MM-DD');
            } catch (error) {
                return '';
            }
        };

        // 扫描相关处理函数
        const handleScanStart = () => {
            // For barcode scan, only validate organization_id
            if (!props.form.organization_id) {
                emit('update:errors', { ...props.errors, jancode: '組織を選択してください' });
                return;
            }
            
            // Clear any error
            emit('update:errors', { ...props.errors, jancode: '' });
            
            barcodeScannerState.value = true;
            
            nextTick(() => {
                if (barcodeScannerRef.value) {
                    // 确保扫描器组件已经挂载
                    setTimeout(() => {
                        if (barcodeScannerRef.value && barcodeScannerRef.value.startScanning) {
                            barcodeScannerRef.value.startScanning();
                        }
                    }, 100);
                }
            });
        };

        const handleScanSuccess = async (jancode: string, scanMeta?: ScanMeta) => {
            try {
                const materialInfoResult = await getJanCodeInfo(jancode);
                // Check if result is an array and use first item
                const materialInfo = Array.isArray(materialInfoResult) && materialInfoResult.length > 0 
                    ? materialInfoResult[0] 
                    : materialInfoResult;
                    
                if (materialInfo && Object.keys(materialInfo).length > 0) {
                    const scannedExpiration =
                        props.form.add_update === 'add' ? scanMeta?.expirationDate : undefined;
                    hasScannedExpirationPriority.value = !!scannedExpiration;

                    let expirationDate = props.form.expiration_date;
                    if (scannedExpiration) {
                        expirationDate = scannedExpiration;
                    } else if (props.form.add_update === 'add') {
                        const calculatedDate = resolveExpirationDateFromDay(
                            materialInfo.expiration_day,
                            props.form.storage_date
                        );
                        if (calculatedDate) {
                            expirationDate = calculatedDate;
                        }
                    }

                    // Prepare all data before updating the form to avoid flicker
                    emit('update:form', {
                        ...props.form,
                        material_code: materialInfo.material_code,
                        material_name: materialInfo.name,
                        category_id: materialInfo.category_id,
                        jancode: materialInfo.jancode,
                        expiration_date: expirationDate,
                    });
                    // 扫描成功后关闭扫描器
                    barcodeScannerState.value = false;
                } else {
                    emit('update:errors', { ...props.errors, jancode: 'アイテムマスタにありません。アイテムマスタに登録してください。' });
                }
            } catch (error) {
                console.error('JANコードの取得に失敗しました。', error);
                emit('update:errors', { ...props.errors, jancode: 'JANコードの取得に失敗しました。' });
            }
        };

        const getJanCodeInfo = async (jancode: string) => {
            try {
                const params = {
                    jancode: jancode,
                    organization_id: props.form.organization_id,
                }

                const res: AxiosResponse<any> = await axios.get(`/api/materials/jancode`, { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    return res.data.data;
                }
                return null;
            } catch (error) {
                return null;
            }
        };




        return {
            formRef,
            alarmFormRef,
            constantFormRef,
            transferInventoryFormRef,
            disabled,
            formVisibleModel,
            alarmVisibleModel,
            constantVisibleModel,
            imagePreviewVisibleModel,
            transferInventoryVisibleModel,
            rules,
            alarmRules,
            constantRules, // Added constantRules to return
            errorsModel,
            handleExceed,
            handleImageChange,
            handleImageRemove,
            handlePictureCardPreview,
            updateOrganizationId,
            updateCategoryId,
            updateExpirationDate,
            ROLES,
            handleSubmit,
            handleAlarmSubmit,
            handleConstantSubmit,
            handleTransferInventorySubmit,
            handleCreateNewRecord,
            handleTargetInventorySelect,
            handleDepartmentChange,
            handleTransferQuantityChange,
            handleStorageDateChange,
            handleExpirationDateChange,
            transferFormRules,
            step2Error,
            formatDate,
            // 图片上传相关状态和函数
            imageUrl,
            // Sorting and pagination for target inventory table
            sortedPaginatedTargetInventory,
            targetInventoryCurrentPage,
            targetInventoryPageSize,
            targetInventoryTotal,
            handleTargetInventoryPageChange,
            handleTargetInventorySort,
            getTargetInventorySortLabel,
            getTargetInventorySortIcon,
            targetInventorySortField,
            // 扫描器相关
            barcodeScannerRef,
            barcodeScannerState,
            handleScanStart,
            handleScanSuccess,
        };
    },
});
</script>

<style scoped>
:deep(.el-input-group__append) {
    padding: 0;
    margin: 0;
}

:deep(.el-input-group__append .el-button) {
    margin: 0;
    border-radius: 0 4px 4px 0;
}

/* Styling for the fake new record row */
.new-record-fake-row {
    background-color: #409eff;
    color: white;
    transition: background-color 0.2s ease;
    height: 40px; /* Match table header height */
}

.new-record-fake-row:hover {
    background-color: #337ecc;
}

/* Table header styling */
:deep(.table-header-row) {
    background-color: black !important;
    color: white !important;
}

:deep(.table-header-row th) {
    background-color: black !important;
    color: white !important;
    border-color: #374151 !important;
}

/* Center radio button properly */
.radio-center {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.radio-center .el-radio__input) {
    margin: 0 auto;
}

:deep(.radio-center .el-radio__label) {
    padding: 0;
}

/* Remove vertical separator lines from table */
:deep(.el-table td),
:deep(.el-table th) {
    border-right: none !important;
}

/* Sort header styling */
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 扫描器容器样式 */
.barcode-scanner-container {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
</style> 